import TimelineComp from "@/components/TimelineComp";
import { WithDefaultLayout } from "../components/DefautLayout";
import { Page } from "../types/Page";
import React, { useState } from "react";
import { Card, Dropdown, Button, MenuProps } from "antd";
import TermCondition from "@/components/TermCondition";
import TitleTemp from "@/components/TitleTemp";
import Workshop from "@/components/Workshop";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faUser,
  faChevronDown,
  IconDefinition,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import { faMedal } from '@fortawesome/free-solid-svg-icons';
import PrizeCard from '@/components/HomeCard';
// import TestimonyCarousel from '../components/testimony/TestimonyCarousel';
import HomeSlides, { HomeSlideParams } from "@/components/HomeSlides";
import Sponsors from "@/components/Sponsors";
// import PrizePoolSection from "@/components/PrizePoolSection";
// import { COMPETITION_ROUTES } from "@/constants/routes";
import ComingSoon from "@/components/ComingSoon";
import MediaPartners from "@/components/MediaPartners";

interface GradeFees {
  grade: string;
  desc: string;
  fee: string;
}

interface Competition {
  url: string;
  name: string | React.ReactNode;
  headerClassName: string;
  gradeFees: GradeFees[];
}

interface CompetitionCategory {
  icon: IconDefinition | React.ReactNode;
  name: string;
  competitions: Competition[];
}

const IndexPage: Page = () => {
  // const ButtonCategory = () => {
  //     return (
  //         <Link
  //             href="/iit-program"
  //             className=" bottom-0 translate-y-1/2 absolute left-1/2 transform -translate-x-1/2 text-white bg-black hover:bg-white hover:text-defaultBlue font-medium rounded-lg md:text-lg text-sm px-6 py-2 text-center"
  //         >
  //             Show Detail
  //         </Link>
  //     )
  // }

  const competitionCategories: CompetitionCategory[] = [
    {
      icon: faUser,
      name: "Individual Competition Category",
      competitions: [
        {
          url: "/iit-program?program=ScratchCoding2026",
          name: "Scratch Coding Game",
          headerClassName: "bg-pink-500",
          gradeFees: [
            {
              grade: "Mix for Elementary Grade 5–6 & Junior High School Grade 7–8",
              desc: "Create an original Scratch game inspired by the SDGs",
              fee: "IDR 100.000",
            },
          ],
        },
        {
          url: "/iit-program?program=CompetitiveProgramming2026",
          name: "Competitive Programming",
          headerClassName: "bg-blue-600",
          gradeFees: [
            {
              grade: "Mix for Junior High School Grade 9 & Senior High School Grade 10–12",
              desc: "Solve algorithmic and problem-solving challenges using C, C++, or Python.",
              fee: "IDR 100.000",
            },
          ],
        },
      ],
    },
    {
      icon: faUserGroup,
      name: "Group Competition Category Max 4 Members",
      competitions: [
        {
          url: "/iit-program?program=InnovativeTechnology2026",
          name: "Innovative Technology Challenge",
          headerClassName: "bg-orange-600",
          gradeFees: [
            {
              grade: "Mix of Elementary School 5th-6th Grade, Junior 7th-9th Grade, and Senior High School 10th-12th Grade.",
              desc: "Develop an innovative technology-based solution related to the SDGs.",
              fee: "IDR 300.000",
            },
          ],
        },
        {
          url: "/iit-program?program=EcoQuest2026",
          name: "EcoQuest AI Web Application",
          headerClassName: "bg-violet-600",
          gradeFees: [
            {
              grade:
                "Mix of Senior High School and Undergraduate-Level Diploma (D3/D4) and Bachelor’s (S1) Students",
              desc: "Develop a responsive village website for Desa Marga Mulya",
              fee: "IDR 300.000",
            },
          ],
        },
      ],
    },
  ];

  // const CategoryCard = ({ children }) => {
  //     return (
  //         <Card
  //             className="p-4 py-0 rounded-md relative focus:ring-4 focus:outline-none focus:ring-blue-300 border border-gray-200 shadow mx-auto w-full transition-colors">
  //             {children}
  //         </Card>
  //     )
  // }

  const CategoryCard = ({ category }: { category: CompetitionCategory }) => {
    const { icon, name, competitions } = category;

    const isFAIcon = (icon: any): icon is IconDefinition => {
      return icon && typeof icon === "object" && "iconName" in icon;
    };

    return (
      <Card className="flex flex-col p-0 sm:p-4 py-0 rounded-md relative border border-gray-200 shadow mx-auto w-full">
        <div className="flex flex-col items-center text-center py-4">
          {isFAIcon(icon) ? (
            <FontAwesomeIcon
              icon={icon}
              style={{ fontSize: "2rem" }}
              className="mb-4"
            />
          ) : (
            icon
          )}

          <h2 className="text-base md:text-lg lg:text-xl font-semibold">
            {name}
          </h2>
        </div>

        <div className="mt-auto">
          {competitions.map((competition, index) => (
            <Link
              key={index}
              href={competition.url}
              className="hover:text-black"
            >
              <div className="shadow rounded-md mb-4 border border-black hover:scale-105 transition-all h-full overflow-hidden">
                <h1
                  className={`text-base font-bold p-3 py-2 ${competition.headerClassName} text-white text-center`}
                >
                  {competition.name}
                </h1>

                <div className="p-3 space-y-3">
                  {competition.gradeFees.map((gf, index) => {
                    const { grade, desc, fee } = gf;

                    return (
                      <div key={index}>
                        <p className="font-semibold">{grade}</p>
                        <p className="text-sm text-gray-600">{desc}</p>
                        {fee && (
                          <p className="font-bold text-red-600">
                            {fee}
                          </p>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </Card>
    );
  };

  const Home = () => {
    const slides: HomeSlideParams[] = [
      // {
      //     title: "Get Ready for the Next Challenge",
      //     subtitle: "IIT returns for 2025",
      //     description: "Get ready for this year's exciting tech challenge! After the success of last year's software programming, presentation, and robot race competitions, we return with a new set of exciting challenges to test your skills.",
      //     backgroundImage: "/images/home-bg.webp",
      //     sideImage: "/images/time.png"
      // },
      // {
      //   title: "View Last Year's Challenge",
      //   subtitle: "Memories from IIT Challenge 2024",
      //   description:
      //     "Take a look back at last year's exciting competition through our curated documentation pictures! Every moment captures teamwork, spirit, and creativity of our contestants.",
      //   backgroundImage: "/images/documentation/IIT2024-Innovative-20.jpg",
      //   sideImage: "/images/pics.png",
      //   button: {
      //     buttonText: "View Documentation",
      //     buttonHref: "/iit-documentation",
      //   },
      // },
      {
        title: "Our Sponsors",
        subtitle: "Supporters Behind the Challenge",
        description:
          "Meet the organizations that made this event possible. Their support fuels innovation, empowers participants, and helps bring the IIT Challenge to life.",
        backgroundImage: "/images/sponsor-bg.jpg",
        sideImage: "/images/Collage-sponsor-logo-placeholder.png",
        button: {
          buttonText: "Contact Us Now!",
          buttonHref: "https://wa.me/6285771210948",
          buttonHrefExternal: true,
        },
      },
      {
        title: "Our Media Partners",
        subtitle: "Partnership for Wider Reach",
        description:
          "Join us as a media partner and help amplify the excitement of the IIT Challenge! Partnering with us gives you the opportunity to connect with a vibrant community of innovators, educators, and students while supporting the growth of technological excellence in Indonesia.",
        backgroundImage: "/images/Media-partners-bg.jpg",
        sideImage: "/images/Collage-media-partner-logo-halffilled.png",
        button: {
          buttonText: "Contact Us Now!",
          buttonHref: "https://wa.me/6285771210948",
          buttonHrefExternal: true,
        },
      },
    ];

    return (
      <div>
        <HomeSlides slides={slides} />
      </div>
    );
  };

  // const Category = () => {
  //     return (
  //         <>
  //             <TitleTemp name="Competition" />
  //             <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:px-8">
  //                 <CategoryCard>
  //                     <FontAwesomeIcon icon={faRobot} style={{ fontSize: "2rem" }} className='mb-4' />
  //                     <h2 className='text-base md:text-lg lg:text-xl font-semibold hover:text-white'>Robot Race</h2>
  //                     <p className="mb-4 text-sm">/Team, Max 2 person</p>
  //                     <h3 className="text-lg font-semibold">IDR 350.000</h3>
  //                     <h3 className="text-base md:text-lg  font-medium">High School (Mix Junior and Senior)</h3>
  //                     <ul className="list-disc ml-4 text-sm">
  //                         <li>Obstacle Avoidance Driving Game </li>
  //                         <li>Sumo game</li>
  //                     </ul>
  //                     <ButtonCategory />
  //                 </CategoryCard>

  //                 <CategoryCard>
  //                     <FontAwesomeIcon icon={faComputer} style={{ fontSize: "2rem" }} className='mb-4' />
  //                     <h2 className='text-base md:text-lg lg:text-xl font-semibold hover:text-white'>Software Programming</h2>
  //                     <p className="mb-4 text-sm">/Individu</p>
  //                     <h3 className="text-base md:text-lg  font-semibold mb-4">IDR 150.000</h3>
  //                     <hr className="my-4 border-gray-400" />
  //                     <h3 className='text-base md:text-lg  font-medium'>Junior High School</h3>
  //                     <h3 className='text-base md:text-lg  font-medium'>Senior High School</h3>
  //                     <ButtonCategory />
  //                 </CategoryCard>

  //                 <CategoryCard>
  //                     <FontAwesomeIcon icon={faPersonChalkboard} style={{ fontSize: "2rem" }} className='mb-4' />
  //                     <h2 className='text-base md:text-lg lg:text-xl font-semibold hover:text-white'>Academic Writing & Presentation</h2>
  //                     <p className=" mb-4 text-sm">/Team, Max 4 person</p>
  //                     <h3 className="text-lg font-semibold">IDR 500.000</h3>
  //                     <h3 className="text-base md:text-lg  font-medium">Elementary School</h3>
  //                     <ul className="list-disc ml-4 text-sm">
  //                         <li>Innovative Technology Challenge</li>
  //                     </ul>
  //                     <hr className="my-4 border-gray-400" />
  //                     <h3 className="text-base md:text-lg font-semibold">IDR 600.000</h3>
  //                     <h3 className="text-base md:text-lg font-medium">High School (Mix Junior and Senior)</h3>
  //                     <ul className="list-disc ml-4 md:mb-12 lg:mb-8 text-sm">
  //                         <li>Student Symposium Research Paper</li>
  //                         <li>Innovative Technology Challenge</li>
  //                     </ul>
  //                     <ButtonCategory />
  //                 </CategoryCard>
  //             </div>
  //         </>
  //     );
  // }

  const CategoryNew = ({ comingSoon = false }: { comingSoon?: boolean }) => {
    if (comingSoon) {
      return (
        <div className="bg-gray-200 shadow py-12 px-4 sm:px-12 mt-2 flex flex-col items-center text-center">
          <div className="-mt-12">
            <TitleTemp name="Competition Category" />
          </div>
          <ComingSoon
            description={`Our competition categories are being prepared. Stay tuned for updates!`}
          />
        </div>
      );
    }

    return (
      <>
        <div className="bg-gray-200 shadow py-12 px-4 sm:px-12 mt-2">
          <div className="-mt-12">
            <TitleTemp name="Competition Category" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 w-full lg:max-w-7xl lg:items-stretch lg:mx-auto">
            {/* <CategoryCard>
                        <div className='flex flex-col items-center md:items-start'>
                            <FontAwesomeIcon icon={faRobot} style={{ fontSize: "2rem" }} className='mb-4' />
                            <h2 className='text-base md:text-lg lg:text-xl font-semibold'>Robot Race</h2>
                            <p className="mb-4 text-sm">/Team, Max 2 person</p>
                        </div>

                        <Link href={'/iit-program?program=Obstacle-Robot'} className='hover:text-black' >
                            <div className='shadow border border-orange-500 rounded-md mb-4  text-black hover:scale-105 transition-all overflow-hidden'>
                                <h1 className='text-base font-bold p-3 py-2 bg-orange-500 text-white'>Obstacle Avoidance Driving Game</h1>
                                <div className='p-3'>
                                    <h1 className='font-bold'>High School (Mix Junior and Senior)</h1>
                                    <h3 className="font-semibold">IDR 350.000</h3>
                                </div>
                            </div>
                        </Link>
                        <Link href={'/iit-program?program=Sumo-Robot'} className='hover:text-black' >
                            <div className='shadow border border-orange-700 rounded-md mb-4  text-black hover:scale-105 transition-all overflow-hidden'>
                                <h1 className='text-base font-bold p-3 py-2 bg-orange-700 text-white'>Sumo game</h1>
                                <div className='p-3'>
                                    <h1 className='font-bold'>High School (Mix Junior and Senior)</h1>
                                    <h3 className="font-semibold">IDR 350.000</h3>
                                </div>
                            </div>
                        </Link>
                    </CategoryCard> */}

            {competitionCategories.map((category, index) => (
              <CategoryCard key={index} category={category} />
            ))}
          </div>
        </div>
      </>
    );
  };

  const Prize = () => {
      return (
        <section id='prize'>
          <div className='my-8'>
              <div className="text-center">
                  <FontAwesomeIcon icon={faMedal} style={{ color: "#00B0F0", fontSize: "5rem" }} />
              </div>
              <TitleTemp name={'Prizes & Benefits'} />
              <div className="mx-auto max-w-screen-lg">
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-8 px-4 sm:px-8 lg:px-0 mx-auto">
                      <PrizeCard
                          title="Competitive Programming"
                          desc={[
                              // 'Medal',
                              // 'Certificate',
                              // 'Software Programming Bootcamp for 2 Months Total IDR 26.550.000',
                              // 'Robotic Race Workshop for WIT Challenge 2024',
                              // 'Subsidies WIT Challenge 2024 Registration Fee',
                              { item: "🥇 1st Place", subItems: ["IDR 500.000"] },
                              { item: "🥈 2nd Place", subItems: ["IDR 300.000"] },
                              { item: "🥉 3rd Place", subItems: ["IDR 200.000"] }

                          ]} />
                      <PrizeCard
                          title="Scratch Coding Game"
                          desc={[
                              { item: "🥇 1st Place", subItems: ["IDR 500.000"] },
                              { item: "🥈 2nd Place", subItems: ["IDR 300.000"] },
                              { item: "🥉 3rd Place", subItems: ["IDR 200.000"] }

                          ]} />

                  
                  
                      <PrizeCard
                          title="Innovative Technology Challenge"
                          desc={[
                              { item: "🥇 1st Place", subItems: ["IDR 1,000,000"] },
                              { item: "🥈 2nd Place", subItems: ["IDR 750,000"] },
                              { item: "🥉 3rd Place", subItems: ["IDR 500,000"] }

                          ]} />
                      <PrizeCard
                          title="EcoQuest Web Application"
                          desc={[
                              { item: "🥇 1st Place", subItems: ["IDR 1,000,000 + Village Visit and Implementation"] },
                              { item: "🥈 2nd Place", subItems: ["IDR 750,000"] },
                              { item: "🥉 3rd Place", subItems: ["IDR 500,000"] }

                          ]} />
                  </div>
                  
                  {/* <div className='mt-8 px-14 lg:px-0 mx-auto'>
                      <PrizeCard
                          title="Senior High School"
                          desc={[
                              'Medal',
                              'Certificate',
                              'Software Programming Bootcamp for 2 Months Total IDR 26.550.000',
                              'Robotic Race Workshop for WIT Challenge 2024',
                              'Software Programming Workshop for WIT Challenge 2024',
                              'Subsidies WIT Challenge 2024 Registration Fee',
                              {
                                  item: 'UKRIDA Scholarship for all faculty',
                                  subItems: [
                                      'The scholarship is still valid for a maximum 3 years after Senior High School graduation.',
                                      `For the all champions, specifically for the medical study program, will get the opportunity to use Ukridian's Family to get the special  entry tuition fee IDR 200.000.0000.`,
                                      'All scholarships must fulfil the additional requirements for specific study programs.',
                                  ]
                              }
                          ]}
                      />

                  </div> */}
                  <div className='mt-2 md:mt-8 px-14 lg:px-0 mx-auto.'>
                      <PrizeCard
                          title="Other Benefits"
                          desc={[
                              '🎖️ Medal',
                              '📜 Certificate',
                              '🚀 2-Month Online Full Stack Developer Bootcamp',
                              '✨ Apply for the Widia Scholarship (Full Scholarship for Up to 4 Years of Study at BINUS University)',
                              '🌱 Village Implementation & Real-World Project Experience',
                              '🏡 Community Service (Comserv) Hours for BINUSIAN'
                          ]}
                      />

                  </div>
              </div>
          </div>
          </section>
      )
  }

  const Sponsor = () => {
    const [selectYear, setSelectYear] = useState(2026);

    const handleMenuClick: MenuProps["onClick"] = (e) => {
      setSelectYear(parseInt(e.key));
    };

    const items: MenuProps["items"] = [
      { key: "2024", label: <a>2024</a> },
      { key: "2026", label: <a>2026</a> },
    ];

    return (
      <section id="sponsor" className="pb-5 pt-28 relative">
        <img
          alt="sponsor bg"
          className="absolute top-0 left-0 h-full w-full object-cover"
          src="/images/sponsor-bg.jpg"
        />
        <div className="w-full h-full absolute top-0 bg-darkBlue bg-opacity-70" />

        <div className="absolute top-6 left-1/2 -translate-x-1/2 flex flex-col w-full">
          <h1 className="flex items-center justify-center text-2xl md:text-4xl font-bold text-white flex-wrap gap-2 mb-4">
            <span className="whitespace-nowrap">Sponsors</span>
            <span className="inline-flex items-center space-x-1">
              <span>{selectYear}</span>
              <Dropdown
                menu={{ items, onClick: handleMenuClick }}
                trigger={["click"]}
              >
                <Button
                  className="text-white font-bold w-6 h-6 flex items-center justify-center bg-defaultBlue hover:bg-darkBlue border-0"
                  icon={
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      style={{ fontSize: "0.75rem" }}
                    />
                  }
                />
              </Dropdown>
            </span>
          </h1>
        </div>

        <div className="relative flex flex-col items-center justify-center md:-mt-6 -mt-10">
          <Sponsors year={selectYear} />
          {(selectYear === 2025 || selectYear === 2026) && (
            <div className="text-center text-white mt-2">
              <a
                onClick={() =>
                  window.open(
                    "https://wa.me/6285771210948",
                    "_blank",
                    "noreferrer",
                  )
                }
                className="text-center text-white cursor-pointer underline text-xl md:text-2xl mr-2 font-bold"
              >
                Contact us to become a sponsor
              </a>
              <FontAwesomeIcon icon={faArrowRight} />
            </div>
          )}
        </div>
      </section>
    );
  };

  const MediaPartner = () => {
    return (
      <section id="media-partner" className="pb-5 pt-28 relative">
        <img
          alt="media-partner bg"
          className="absolute top-0 left-0 h-full w-full object-cover"
          src="/images/Media-partners-bg.jpg"
        />
        <div className="w-full h-full absolute top-0 bg-darkBlue bg-opacity-70" />

        <div className="absolute top-6 left-1/2 -translate-x-1/2 flex flex-col w-full">
          <h1 className="flex items-center justify-center text-2xl md:text-4xl font-bold text-white flex-wrap gap-2 mb-4">
            <span className="whitespace-nowrap">Media Partner</span>
          </h1>
        </div>

        <div className="relative flex flex-col items-center justify-center md:-mt-6 -mt-10">
          <MediaPartners />
          <div className="text-center text-white mt-2">
            <a
              onClick={() =>
                window.open(
                  "https://wa.me/6285771210948",
                  "_blank",
                  "noreferrer",
                )
              }
              className="text-center text-white cursor-pointer underline text-xl md:text-2xl mr-2 font-bold"
            >
              Contact us to become media partner
            </a>
            <FontAwesomeIcon icon={faArrowRight} />
          </div>
        </div>
      </section>
    );
  };

  const Render = () => {
    const dateTimeline = [
      // "5 September 2026",
      // "12 October 2026",
      // "17 October 2026",
      // "19 October 2026 (15.00 WIB)",
      // "24 October 2026",
      // "20–22 November 2026",
      "5 September 2026",
      "20 November 2026",
      "25 November 2026",
      "29 November 2026 (23:59 WIB)",
      "5 December 2026",
      "30 November - 5 December 2026",
      "6 December 2026",
      "6 December 2026",
      "12 December 2026",
      "19-20 December 2026",
    ];

    const descTimeline = [
      // "Open Registration",
      // "Regular Registration Closes",
      // "Finalist Technical Meeting",
      // "Project Synopsis Submission (Scratch Game, Innovation, and EcoQuest)",
      // "Final Competition (Onsite) - BINUS University Alam Sutera",
      // "EcoQuest Village Implementation Program (Onsite) - Desa Marga Mulya",
      "Open Registration",
      "Regular Registration Closes",
      "Technical Meeting Preliminary",
      "Preliminary Submission",
      "Live Competition Preliminary Coding",
      "Judging Preliminary",
      "Announcement 10 Finalist",
      "Technical Meeting Finalist",
      "Final Competition (Onsite) - BINUS University Alam Sutera",
      "EcoQuest Village Implementation Program (Onsite) - Desa Marga Mulya",
    ];
    // const colorTimeline = [
    //   "#34d399",
    //   "#00b0f0",
    //   "#a78bfa",
    //   "#facc15",
    //   "#fb7185",
    //   "#38bdf8",
    //   "#38bdf8",
    // ];
    const colorTimeline = [
      "#F59E0B",
      "#10B981",
      "#2563EB",
      "#7C3AED",
      "#D97706",
      "#E11D48",
      "#0891B2",
      "#0EA5E9",
      "#a78bfa",
      "#22C55E",
      "#65A30D",
    ];
    return (
      <div className="overflow-hidden -mb-8">
        {Home()}
        <TimelineComp
          desc={descTimeline}
          dates={dateTimeline}
          colors={colorTimeline}
          showTitle={true}
          // comingSoon
        />
        {/* <div className="container mx-auto">
                    {CategoryNew()}
                </div> */}
        {/* {CategoryNew()} */}
        <CategoryNew />
        {Sponsor()}
        <div className="my-8 md:my-12" />
        {MediaPartner()}
        <div className="container mx-auto">
          <Prize />
        </div>
        <Workshop />
        <TermCondition />
        {/* <TestimonyCarousel /> */}
      </div>
    );
  };

  return <div>{Render()}</div>;
};

IndexPage.layout = WithDefaultLayout;
export default IndexPage;
